import { useRemoveDeliveryAddressMutation } from 'generated/graphql-gateway';
import { useAuthContext } from 'state/auth';

export const useRemoveDeliveryAddress = () => {
  const { refreshCurrentUser } = useAuthContext();
  const [removeDeliveryAddress, { loading, data, error }] = useRemoveDeliveryAddressMutation({
    onCompleted: () => {
      refreshCurrentUser();
    },
    onError: () => {
      refreshCurrentUser();
    },
  });

  return {
    removeDeliveryAddress,
    loading,
    data,
    error,
  };
};
